export enum HashPurpose {
  ServerAuthorization = 1,
  LocalAuthorization = 2,
}
